import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  showWarningMessage,
  showErrorMessage,
  API_URL,
};
export const GET_DOCUMENTTYPES = `${API_URL}/MasterDocumentTypesStaff/GetDocumentTypes`;
export const POST_DOCUMENTTYPES = `${API_URL}/MasterDocumentTypesStaff/SaveDocumentTypes`;
export const GET_DOCUMENTTYPES_BY_ID = `${API_URL}/MasterDocumentTypesStaff/GetDocumentTypesById`;
export const DELETE_DOCUMENTTYPES = `${API_URL}/MasterDocumentTypesStaff/DeleteDocumentTypes`;
export const GET_MASTERDATABYNAME = `${API_URL}/api/MasterData/MasterDataByName`;

export const documentTypeActionTypes = {
  get_documenttype: createRequestActionTypes('GET_DOCUMENTTYPES'),
  post_documenttype: createRequestActionTypes('POST_DOCUMENTTYPES'),
  get_documenttype_by_id: createRequestActionTypes('GET_DOCUMENTTYPES_BY_ID'),
  delete_documenttype: createRequestActionTypes('DELETE_DOCUMENTTYPES'),
  get_masterData: createRequestActionTypes('GET_MASTERDATA'),
};
export const MODULE = 'MASTER_DOCUMENTTYPESSTAFF';



// WEBPACK FOOTER //
// ./src/modules/Masters/components/masterDocumentTypesStaff/constants/ApiConstants.js